import { createAction, props } from '@ngrx/store';
import { UnitAllData } from '../../../units/models/unit-all-data';
import { TripTypeEnum } from '../../../shared/models/trip-type.enum';
import { StartRoute } from '../../../shared/models/startRoute';
import { RouteDetails } from '../../../shared/models/route-details';


export const startRoute = createAction(
  '[Driving] Start Route',
  props<{unit: UnitAllData, tripType: TripTypeEnum}>()
);
export const startRouteSuccess = createAction(
  '[Driving] Start Route Success',
  props<{data: StartRoute}>()
);
export const startRouteFailure = createAction(
  '[Driving] Start Route Failure',
  props<{error: any}>()
);


export const stopRoute = createAction(
  '[Driving] Stop Route',
  props<{unitId: number}>()
);
export const stopRouteSuccess = createAction(
  '[Driving] Stop Route Success',
  props<{data: Partial<StartRoute>}>()
);
export const stopRouteFailure = createAction(
  '[Driving] Stop Route Failure',
  props<{error: any}>()
);


export const getRoute = createAction(
  '[Driving] Get Route',
  props<{unitId: number, dateFrom: string, dateTo: string}>()
);
export const getRouteSuccess = createAction(
  '[Driving] Get Route Success',
  props<{route: RouteDetails}>()
);
export const getRouteFailure = createAction(
  '[Driving] Get Route Failure',
  props<{error: any}>()
);


export const clearRoute = createAction(
  '[Driving] Clear Route'
);

export const getDriving = createAction(
  '[Driving] Get Driving'
);
export const getDrivingSuccess = createAction(
  '[Driving] Get Driving Success',
  props<{data: StartRoute}>()
);
export const getDrivingFailure = createAction(
  '[Driving] Get Driving Failure',
  props<{error: any}>()
);

export type DrivingActionsUnion = ReturnType<
  typeof startRoute |
  typeof startRouteSuccess |
  typeof startRouteFailure |
  typeof stopRoute |
  typeof stopRouteSuccess |
  typeof stopRouteFailure |
  typeof getRoute |
  typeof getRouteSuccess |
  typeof getRouteFailure |
  typeof clearRoute |
  typeof getDriving |
  typeof getDrivingSuccess |
  typeof getDrivingFailure
  >;
